<script>
    import { Chart, registerables } from "chart.js";

    Chart.register(...registerables);

    export default {
        name: "BarChart",
        data() {
            return {
                chart: null,
            };
        },
        mounted() {
            this.createChart();
        },
        methods: {
            createChart() {
                const ctx = this.$refs.chartCanvas.getContext("2d");
                this.chart = new Chart(ctx, {
                    type: "bar",
                    data: this.data,
                    options: {
                        responsive: true,
                        scales: {
                            y: { beginAtZero: true },
                        },
                    },
                });
            },
        },
        beforeUnmount() {
            if (this.chart) {
                this.chart.destroy();
            }
        },
        props: {
            data: Object
        }
    };
</script>

<template>
    <canvas ref="chartCanvas"></canvas>
</template>
